export const globalVars = {
    useProxyApiCalls: true
}